import {
	GenericTableSimpleCell,
	type SimpleCellIcon,
} from '@/libraries/design/patterns/table/src/generic-table-simple-cell.tsx';

export interface UniformSimpleTableCellProps {
	text?: string;
	icon?: SimpleCellIcon;
}

const UniformSimpleTableCell = ({ text, icon }: UniformSimpleTableCellProps) => {
	return <GenericTableSimpleCell text={text} icon={icon} />;
};

export default UniformSimpleTableCell;
